// extracted by mini-css-extract-plugin
export default {"tickertext":"EventTicker_tickertext__85Etz","event":"EventTicker_event__rgCLn","special":"EventTicker_special__o62Lr"};